<div class="sponsor-cards-container">
    <!-- <div class="sponsor-card">
        <div class="sponsor-card-header">Estimated Savings</div>
        <div class="sponsor-card-content">
            <div class="sponsor-card-main">
                <span class="sponsor-card-value">${{245000 || 0 | number:'1.2-2'}}</span>

            </div>
        </div>
        <div class="sponsor-card-icon site-icon">
            <i class=" mi-doller wh-24"></i>
        </div>
    </div> -->
    <div class="sponsor-card">
        <div class="sponsor-card-header">Active Patients Count</div>
        <div class="sponsor-card-content">
            <div class="sponsor-card-main">
                <span class="sponsor-card-value">{{protocolForecastData?.totalAPCount || 0 }}</span>
                <span class="sponsor-card-divider">/</span>
                <span class="sponsor-card-total">{{protocolForecastData?.totalEPCount || 0 }}</span>
            </div>
            <div class="sponsor-card-desc">Active Patients / Estimated Patients</div>
        </div>
        <div class="sponsor-card-icon site-icon">
            <i class="mi-patient-dashboard wh-24"> </i>
        </div>
    </div>
    <div class="sponsor-card">
        <div class="sponsor-card-header">Site Count</div>
        <div class="sponsor-card-content">
            <div class="sponsor-card-main">
                <span class="sponsor-card-value">{{protocolForecastData?.totalSiteCount || 0 }}</span>
            </div>
            <div class="sponsor-card-desc">Total Sites</div>
        </div>
        <div class="sponsor-card-icon site-icon">
            <i class=" mi-site wh-24"></i>
        </div>
    </div>
</div>